import commonMixin from "@/components/common/mini-table/mixins/common-mixin";
import EmCommonApi from "@/mixin/em/common/api";

export default {
    mixins: [EmCommonApi, commonMixin],
    props: {
        filterHolder: Object,

        enableQueryData: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            newRow: {},

            deleteIds: [],
        }
    },
    watch: {
        newRow: {
            handler() {
                if (this.saveHolder && Object.keys(this.newRow).length === 0) {
                    this.newRow = this.deepCopy(this.saveHolder);
                }
            },
            immediate: true
        },
    },
    mounted() {
        if (this.entityName && (!this.readOnly || this.enableQueryData)) {
            this.getRemoteData();
        }
    },
    methods: {
        getRemoteData() {
            this.tableLoading = true;
            let filter = this.filterHolder ? this.filterHolder : {};
            this.$store.dispatch('api/post', {
                url: `${this.$_emApiMixin_moduleBaseApi(this.entityName)}/${this.entityName}/findByFilter`,
                data: filter
            }).then(response => {
                if (response.data.list.length > 0) {
                    for (let row of response.data.list) {
                        let has = false;
                        for (let item of this.rowList) {
                            if (item.id === row.id) {
                                this.copyObj2Obj(row, item);
                                has = true;
                            }
                        }
                        if (!has) {
                            this.rowList.push(row);
                        }
                    }
                }
            }).finally(() => this.tableLoading = false);
        },
        //new or edit one row
        submitForm() {
            this.copyObj2Obj(this.getInputGroupRef().getInputData(), this.newRow, true);
            if (this.getRowFormModalRef().getTempObject() !== 'edit') {
                this.rowList.push(this.newRow);
            }
            this.newRow = {};
            this.getRefEl('miniTable').refresh();
        },
        //when click edit button
        editRow() {
            if (this.isSelectOne) {
                this.newRow = this.selected[0];
                this.getRowFormModalRef().showModal('edit');
                this.$nextTick(() => this.getInputGroupRef().initInputData(this.newRow));
            }
        },
        //when click delete button
        deleteRow() {
            this.selected.sort((a, b) => b._index - a._index);
            this.selected.forEach(o => {
                if (o.hasOwnProperty('id') && o.id) {
                    this.deleteIds.push(o.id);//标记删除
                }
                for (let i = 0; i < this.rowList.length; i++) {
                    if (this.rowList[i]._index === o._index) {
                        this.rowList.splice(i, 1);
                        break;
                    }
                }
            });
            this.selected = [];
        },
        //do save table request
        saveTable() {
            this.doDeleteRows();
            if (this.rowList.length > 0) {
                this.$store.dispatch('api/put', {
                    url: `${this.$_emApiMixin_moduleBaseApi(this.entityName)}/${this.entityName}/saveAllSelective`,
                    entity: this.rowList
                });
            }
        },
        //do delete rows request
        doDeleteRows() {
            if (this.deleteIds.length > 0) {
                this.$store.dispatch('api/delete', {
                    url: `${this.$_emApiMixin_moduleBaseApi(this.entityName)}/${this.entityName}?id=` + this.deleteIds.join(","),
                });
            }
        },
        //when click add button
        doAddOperation() {
            if (this.hasFieldEdit) {
                this.rowList.push(this.newRow);
                this.newRow = {};
            } else {
                this.getRowFormModalRef().showModal('add');
            }
        },
        getSaveRequest() {
            let tempList = [];
            if (this.rowList.length > 0) {
                tempList.push({
                    url: `${this.$_emApiMixin_moduleBaseApi(this.entityName)}/${this.entityName}/saveAllSelective`,
                    httpType: 'put',
                    entity: this.rowList
                });
            }
            if (this.deleteIds.length > 0) {
                tempList.push({
                    url: `${this.$_emApiMixin_moduleBaseApi(this.entityName)}/${this.entityName}?id=` + this.deleteIds.join(","),
                    httpType: 'delete'
                })
            }
            return tempList;
        },

        getRowFormModalRef() {
            return this.getRefEl('rowFormModal');
        },
        getInputGroupRef() {
            return this.getRefEl('inputGroup')
        },
    }
}
